const timeWindow = 5000;

export function generateIdempotencyKey(): string {
  return 'quiz-' + Math.floor(Date.now() / timeWindow);
}
